import { MapPin } from "lucide-react";
import { Reveal, Eyebrow, MaskLines } from "./Reveal";
import { scrollToId } from "./smooth";
import { useT } from "../../lib/content";
import { imgSrc } from "../../data/artworks";

export const Expo = () => {
  const t = useT();
  return (
  <section id="exposition" className="relative bg-[#15202B] text-[#F6F1E9] py-24 sm:py-32 overflow-hidden grain" data-testid="exhibition-section">
    <img src={imgSrc(t("expo_image"))} alt="" aria-hidden="true" className="absolute right-0 top-0 h-full w-1/2 object-cover opacity-[0.12] hidden md:block" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 grid lg:grid-cols-12 gap-12 items-center">
      <div className="lg:col-span-5" data-testid="exhibition-date-badge">
        <Eyebrow light>{t("expo_eyebrow")}</Eyebrow>
        <div className="f-display font-light leading-[0.85] mt-6 text-[7rem] sm:text-[10rem] lg:text-[12rem] text-[#E0C48C]">
          <MaskLines inView lines={[t("expo_dates")]} />
        </div>
        <p className="text-sm tracking-[0.32em] uppercase mt-2 text-slate-200">{t("expo_month")}</p>
      </div>
      <div className="lg:col-span-6 lg:col-start-7">
        <h2 className="f-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.02]">
          <MaskLines inView lines={[t("expo_title1"), <em key="e">{t("expo_title2")}</em>]} />
        </h2>
        <Reveal className="mt-6 text-slate-300 text-base sm:text-lg font-light leading-relaxed max-w-lg">
          {t("expo_text")}
        </Reveal>
        <Reveal delay={0.1} className="mt-6 flex items-center gap-2 text-slate-200"><MapPin className="w-4 h-4 text-[#E0C48C]" /> {t("expo_place")}</Reveal>
        <button onClick={() => scrollToId("contact")} data-testid="exhibition-inquire-button" className="btn-gold mt-10">{t("expo_cta")}</button>
      </div>
    </div>
  </section>
  );
};
